var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupertransfer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1580_967)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 235.5,
    fill: "white",
    stroke: "white",
    strokeWidth: 29
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.562 201.065L235.571 193.505",
    stroke: "black",
    strokeWidth: 22.2504,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.484 207.817L125.78 205.752",
    stroke: "black",
    strokeWidth: 22.2504,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.57 264.338L216.538 253.967",
    stroke: "black",
    strokeWidth: 22.2504,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.961 313.932L225.48 307.385",
    stroke: "black",
    strokeWidth: 22.2504,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1953 322.15L123.735 318.607",
    stroke: "black",
    strokeWidth: 22.2504,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.557 132.757C258.961 124.414 267.256 118.292 275.052 121.321L411.349 174.282L417.727 263.485C418.35 272.199 413.618 280.418 405.769 284.255L292.686 339.536C284.207 343.681 274.225 337.935 273.552 328.52L268.581 258.979C268.026 251.223 272.2 243.896 279.154 240.417L411.349 174.282L297.81 231.084L280.47 227.06C271.903 225.072 265.632 217.734 265.005 208.962L259.557 132.757Z",
    fill: "#FEF4E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.349 174.282L275.052 121.321C267.256 118.292 258.961 124.414 259.557 132.757L265.005 208.962C265.632 217.734 271.903 225.072 280.47 227.06L297.81 231.084L411.349 174.282ZM411.349 174.282L417.727 263.485C418.35 272.199 413.618 280.418 405.769 284.255L292.686 339.536C284.207 343.681 274.225 337.935 273.552 328.52L268.581 258.979C268.026 251.223 272.2 243.896 279.154 240.417L411.349 174.282Z",
    stroke: "black",
    strokeWidth: 2.4715
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.565 255.968L414.148 194.179L302.919 250.952C302.927 250.967 302.94 250.989 302.956 251.018C302.989 251.077 303.037 251.165 303.097 251.278C303.218 251.505 303.385 251.835 303.574 252.248C303.953 253.074 304.419 254.23 304.77 255.554C305.47 258.201 305.709 261.523 303.85 264.205C303.017 265.406 301.633 266.388 300.028 267.185C298.423 267.981 296.594 268.595 294.87 269.058C293.146 269.521 291.526 269.835 290.337 270.033C289.742 270.131 289.256 270.201 288.917 270.247C288.748 270.269 288.616 270.286 288.526 270.297C288.482 270.302 288.447 270.306 288.424 270.309L288.415 270.31L290.804 303.723C290.822 303.713 290.847 303.698 290.878 303.68C290.952 303.638 291.06 303.576 291.2 303.497C291.48 303.34 291.886 303.116 292.391 302.851C293.402 302.321 294.809 301.625 296.395 300.959C297.98 300.293 299.745 299.657 301.47 299.25C303.196 298.842 304.884 298.662 306.317 298.909C309.267 299.417 310.549 301.885 311.093 304.216C311.365 305.382 311.454 306.516 311.474 307.358C311.484 307.78 311.478 308.128 311.468 308.371C311.464 308.493 311.458 308.588 311.454 308.653C311.453 308.674 311.452 308.691 311.451 308.705L418.565 255.968Z",
    fill: "#4045A1",
    stroke: "black",
    strokeWidth: 0.0541961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.236 183.688L326.585 216.482L296.175 210.095C296.18 210.079 296.188 210.055 296.198 210.026C296.219 209.961 296.25 209.866 296.288 209.743C296.363 209.498 296.465 209.142 296.574 208.701C296.792 207.82 297.036 206.597 297.143 205.232C297.357 202.504 297.02 199.203 294.808 196.931C293.817 195.912 292.342 195.215 290.69 194.742C289.038 194.268 287.206 194.017 285.498 193.893C283.791 193.77 282.206 193.772 281.049 193.806C280.47 193.823 279.998 193.848 279.671 193.868C279.507 193.878 279.38 193.888 279.293 193.894C279.25 193.897 279.217 193.9 279.195 193.902L279.187 193.903L275.782 160.698C275.801 160.705 275.826 160.715 275.858 160.726C275.935 160.753 276.048 160.794 276.193 160.844C276.484 160.944 276.906 161.086 277.429 161.249C278.474 161.575 279.921 161.988 281.533 162.337C283.144 162.686 284.919 162.971 286.619 163.04C288.319 163.109 289.945 162.962 291.257 162.446C293.96 161.382 294.752 158.718 294.872 156.33C294.931 155.135 294.823 154.007 294.699 153.178C294.638 152.763 294.572 152.423 294.522 152.186C294.497 152.068 294.476 151.976 294.461 151.913L294.456 151.893C294.454 151.882 294.451 151.873 294.449 151.865L389.236 183.688Z",
    fill: "#4045A1",
    stroke: "black",
    strokeWidth: 0.0541961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.164 250.687L344.705 238.863L346.307 242.188L337.047 246.649C337.047 246.649 341.657 248.689 342.746 250.95L349.035 247.92L350.509 250.978L344.487 253.88C344.487 253.88 348.255 264.78 336.413 269.699L358.602 279.753L352.982 282.461L330.941 273.056L329.301 269.652C329.301 269.652 336.388 266.499 338.644 262.627C340.463 259.489 339.577 258.539 339.305 257.359C339.193 256.922 338.719 256.692 338.318 256.885L326.008 262.816L324.534 259.757L337.139 253.684C337.406 253.555 337.439 253.212 337.19 253.037C336.154 252.258 333.621 250.626 331.463 251.142C328.664 251.836 322.15 254.81 322.15 254.81L320.164 250.687Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1580_967"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    rx: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupertransfer);
export default __webpack_public_path__ + "static/media/super transfer.da550a93dbaa2be873963b07fd057a37.svg";
export { ForwardRef as ReactComponent };